import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import { pipViewDate } from "../../../utils/pip";
import { coachPaths } from "../../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../../components/form/NoRecord";
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";
import TableHeader from "../../../components/table/tableHeader";
import ReactPagination from "../../../components/table/ReactPagination";
import PaginationDropdown from "../../../components/table/PaginationDropdown";
import CreateWebinar from "../../../components/Modals/common/webinar/CreateWebinar";
import ConfirmationModal from "../../../components/Modals/common/webinar/ConfirmationModal";
import {
  deleteWebinar,
  deleteWorkShop,
  fetchWorkshop,
  fetchCoachWebinar,
  fetchCoachBookedWebinar,
  fetchWorkshopBookings,
  toggleWorkShopStatus,
} from "../../../redux/features/coach/actions/authAction";
import WebinarDetails from "../../../components/pages/admin/modals/WebinarDetails";
import WorkshopDetails from "../../../components/pages/admin/modals/WorkshopDetails";

const Event = () => {
  const navigate = useNavigate();
  const [id, setId] = useState("");
  const [isToggle, setIsToggle] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isWorkShopBookingModal, setIsWorkShopBookingModal] = useState(false);

  const dispatch = useDispatch();
  const [activeCoach, setActiveCoach] = useState(null);
  const [activeWorkshopBooking, setActiveWorkshopBooking] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [isWebCreateModal, setIsWebCreateModal] = useState(false);
  const { eventData, isLoading, tabs, tableHeaders } = useSelector(
    (state) => state?.coach?.auth
  );
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const [isActiveTab, setIsActiveTab] = useState("webinar");

  const paginatedList = eventData[activeTab]?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  useEffect(() => {
    dispatch(fetchCoachWebinar());
    dispatch(fetchCoachBookedWebinar());
    dispatch(fetchWorkshop());
    dispatch(fetchWorkshopBookings());
  }, []);

  const handleDeleteWebinar = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchCoachWebinar());
      }
    };
    dispatch(deleteWebinar({ payload: id, callback }));
  };

  const handleDeleteWorkshop = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchWorkshop());
      }
    };
    dispatch(deleteWorkShop({ payload: id, callback }));
  };

  const handleToggleWorkShopStatus = (id) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchWorkshop());
      }
    };
    dispatch(toggleWorkShopStatus({ id, callback }));
  };

  const tableBody = (item, index) => {
    switch (activeTab) {
      case tabs[0].value:
        return (
          <tr>
            <td>{index + 1}</td>
            <td>
              <p className="ct_overlay_text mb-0">
                {item?.section_1?.title ?? ""}
              </p>
            </td>
            <td>{pipViewDate(item?.schedule_date) ?? ""}</td>
            <td>
              <p className="ct_overlay_text">
                {item?.section_5?.cards
                  ? item?.section_5?.cards[0]?.text_2 || ""
                  : ""}
              </p>
            </td>
            <td>
              <div className="ct_right_dropdown dropdown">
                <button
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-ellipsis"></i>
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => {
                        navigate(`${coachPaths.WebinarDetail}?webinar_id=${item?.webinar_id}`, {
                          state: { data: item },
                        });
                      }}
                    >
                      View
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item ct_darksky_blue_text"
                      onClick={() => {
                        navigate(coachPaths.UpdateWebinar, {
                          state: { data: item },
                        });
                      }}
                    >
                      Edit
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item text-danger"
                      onClick={() => setId(item?.webinar_id)}
                      data-bs-target="#ct_remove_webinar"
                      data-bs-toggle="modal"
                    >
                      Remove
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        );
      case tabs[1].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                {item?.first_name ?? ""} {item?.last_name ?? ""}
              </td>
              <td>{pipViewDate(item?.created_at) ?? ""}</td>
              <td>{item?.phone_number ?? ""}</td>
              <td>{item?.role ?? ""}</td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          setActiveCoach(item);
                          setIsModal(true);
                        }}
                      >
                        View
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[2].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_1?.title ?? ""}
                </p>
              </td>
              <td>{pipViewDate(item?.schedule_date) ?? ""}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_4?.cards
                    ? item?.section_4?.cards[0]?.text_2 || ""
                    : ""}
                </p>
              </td>
              <td>
                <select
                  className="form-control ct_input border-0 ct_fit_content"
                  onChange={(e) => {
                    handleToggleWorkShopStatus(item?.workshop_id);
                  }}
                  value={item?.status}
                >
                  <option value={"Draft"}>Draft</option>
                  <option value={"Publish"}>Publish</option>
                </select>
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      {console.log({ item })}
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(`${coachPaths.coachWorkshop_deats}?workshop_id=${item?.workshop_id}`, {
                            state: { data: item },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        onClick={() => {
                          navigate(coachPaths.coachUpdateWorkShopDetails, {
                            state: { data: item },
                          });
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.workshop_id)}
                        data-bs-target="#ct_remove_workshop"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[3].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">{item?.title ?? ""}</p>
              </td>
              <td>
                <p className="ct_overlay_text">{item?.name ?? ""}</p>
              </td>
              <td>{item?.email ?? ""}</td>
              {/* <td>{item?.timezone ?? ""}</td> */}
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          setActiveWorkshopBooking(item);
                          setIsWorkShopBookingModal(true);
                        }}
                      >
                        View
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
    }
  };

  const renderCreateButton = () => {
    switch (activeTab) {
      case tabs[0].value:
        return (
          <button
            className="ct_yellow_btn ct_h_35 ct_w_100_575"
            onClick={() => {
              setIsActiveTab("webinar");
              setIsWebCreateModal(true);
            }}
          >
            Create webinar
          </button>
        );
      case tabs[2].value:
        return (
          <button
            className="ct_yellow_btn ct_h_35 ct_w_100_575"
            onClick={() => {
              setIsActiveTab("workshop");
              setIsWebCreateModal(true);
            }}
          >
            Create workshop
          </button>
        );
      default:
        break;
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <CoachMenuLayout>
      <div className="ct_px_40 mt-4">
        <div className="row">
          <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
            {/* <h4 className="mb-0 ct_fs_20 mb-4">Coach List</h4> */}
            <div className="ct_filter_btn">
              <button
                className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"
                onClick={() => {
                  setIsToggle(true);
                }}
              >
                Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
              </button>
            </div>
            <div
              className={`ct_filter_sidebar ct_custom_scroll p-0 ${isToggle ? "show" : ""
                }`}
            >
              <div
                className="ct_close_filter d-block d-lg-none"
                onClick={() => {
                  setIsToggle(false);
                }}
              >
                <i className="fa-solid fa-xmark"></i>
              </div>
              <div className="mt-4">
                <h5 className="ct_fs_16 mb-3">Account Status</h5>
                <ul>
                  <li>
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Active
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Suspended
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Pending Approval
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Deactivated
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mt-4">
                <h5 className="ct_fs_16 mb-3">Activity Level</h5>
                <ul>
                  <li>
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Last Active: Today
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Last 7 Days
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        30+ Days Inactive
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mt-4">
                <h5 className="ct_fs_16 mb-3">User Plan</h5>
                <ul>
                  <li>
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Nuglow
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Nuforge
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Nustar
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Free
                      </label>
                    </div>
                  </li>
                  <li className="mt-2">
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Others
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mt-4">
                <h5 className="ct_fs_16 mb-3">Flagged</h5>
                <ul>
                  <li>
                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Show Only Flagged Users
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-9 mb-4 mb-md-0">
            <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
              <div>
                <h4 className="mb-0 ct_fs_20 mb-0">Manage Content</h4>
                <p className="mb-0 ct_text_clr_757886">
                  View, filter, and take action across all Nuvio user types
                </p>
              </div>
              <div className="d-flex align-items-center gap-3 justify-content-end  ct_flex_col_575">
                <div className="position-relative ct_w_100_575">
                  <input
                    type="text"
                    className="form-control ct_input ct_h_35 ps-5"
                    placeholder="Search by Name"
                  />
                  <i className="fa-solid fa-search ct_input_icon_left"></i>
                </div>
                {renderCreateButton()}
              </div>
            </div>
            <div
              className="d-flex align-items-center gap-3 justify-content-between mb-3 ct_flex_col_575 ct_pb_3_575"
              style={{ borderBottom: "1px solid #cccccc" }}
            >
              <ul className="ct_table_filter">
                {tabs.map((item, ind) => {
                  return (
                    <li
                      className={activeTab == item?.value ? "active" : ""}
                      onClick={() => {
                        setActiveTab(item?.value);
                        setIsActiveTab(
                          item?.value == "webinar"
                            ? "webinar"
                            : item?.value == "work_shop" && "workshop"
                        );
                      }}
                    >
                      {item?.label} ({eventData[item?.value]?.length || 0})
                    </li>
                  );
                })}
              </ul>
            </div>
            {/* Webinar Table S */}
            <div className={`d-block`}>
              <div className="table-responsive ct_custom_table ct_custom_table2 pt-2">
                <table className="table">
                  <TableHeader data={tableHeaders[activeTab]} />
                  {paginatedList?.length > 0 && (
                    <tbody>
                      {paginatedList?.map((user, index) =>
                        tableBody(user, index)
                      )}
                    </tbody>
                  )}
                </table>
                {paginatedList?.length <= 0 && <NoRecord />}
              </div>
              {paginatedList?.length != 0 && (
                <div className="d-flex justify-content-between align-items-center mt-4 ">
                  <div>
                    <PaginationDropdown
                      onChange={(val) => {
                        setListPerPages(val);
                        setCurrentPage(0);
                      }}
                    />
                  </div>
                  <div>
                    <ReactPagination
                      pageCount={Math.ceil(
                        eventData[activeTab]?.length / listPerPages
                      )}
                      onPageChange={handlePageClick}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isWebCreateModal && (
        <CreateWebinar
          setIsWebCreateModal={setIsWebCreateModal}
          isWebinar={isActiveTab}
        />
      )}

      <ConfirmationModal
        id="ct_remove_webinar"
        title="Delete Webinar"
        onConfirm={handleDeleteWebinar}
      />

      <ConfirmationModal
        id="ct_remove_workshop"
        title="Delete WorkShop"
        onConfirm={handleDeleteWorkshop}
      />

      <WebinarDetails
        isModal={isModal}
        setIsModal={setIsModal}
        data={activeCoach}
      />
      <WorkshopDetails
        isModal={isWorkShopBookingModal}
        setIsModal={setIsWorkShopBookingModal}
        data={activeWorkshopBooking}
      />
    </CoachMenuLayout>
  );
};

export default Event;
